import React from 'react'
import Layout from '../../Layout/Layout'
import DetailsSection1 from './DetailsSection1'
import Footer from '../../Layout/Footer'
// import DetailsSection2 from './DetailsSection2'

import DetailsSection2 from './DetailsSection2'
import FooterNew from '../../Layout/FooterNew'

function DetailsPage() {
  return (
    <>
    <Layout/>
    <DetailsSection1/>
 

    <DetailsSection2/>
    {/* <Footer/> */}
    <FooterNew/>
    </>
  )
}

export default DetailsPage
